import { useScope } from "~/hooks/useScope";
import { OrganizationPoliciesAddQueryDetailPage } from "~/pages/organization/policies-add/OrganizationPoliciesAddQueryDetailPage";

export function OrganizationPoliciesAddQueryDetailEntryPage() {
  const { organizationScope } = useScope();
  return organizationScope ? (
    <OrganizationPoliciesAddQueryDetailPage scope={organizationScope} />
  ) : undefined;
}
